export default function toggle(bool: boolean): boolean {
  return !bool;
}
